import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import api from 'API';
import { AddUser, CryptoLogo, FinanceLogo, Reset, UnifyLogo } from 'IMAGE';
import { Button } from 'antd';
import { NavLink } from 'react-router-dom';

const OAuthPopup = ({ successCallback, route }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const popupRef = useRef(null);
  const intervalRef = useRef(null);

  // Функция для получения URL авторизации
  const getAuthUrl = async (space) => {
    try {
      setIsLoading(true);
      setError(null);

      const response = await axios(api.users.authorization.loginByOauth(space).AXIOS('GET'));

      if (response.status !== 200) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return response.data.url;
    } catch (err) {
      setError(err.message);
      console.log(error);
      throw err;
    } finally {
      setIsLoading(false);
      console.log(isLoading);
    }
  };

  // Очистка интервала
  const clearPopupInterval = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  // Закрытие popup
  const closePopup = () => {
    console.log('closePopup в closePopup');
    if (popupRef.current && !popupRef.current.closed) {
      popupRef.current.close();
      popupRef.current = null;
    }
    clearPopupInterval();
  };

  // Обработка успешной авторизации
  const handleOAuthSuccess = (tokenData) => {
    console.log('OAuth successful!', tokenData);

    if (successCallback) {
      successCallback(tokenData);
    } else {
      alert('Authentication successful! Token received.');
    }
  };

  // Эффект для обработки сообщений
  useEffect(() => {
    const messageHandler = (event) => {
      // В продакшене нужно проверять origin сообщения!
      // if (event.origin !== 'https://your-app.com') return;

      // console.log('Received message:', event.data);

      // Проверяем структуру данных
      if (event.data && event.data.user) {
        const tokenData = event.data;
        console.log('Received token data:', tokenData);

        // Закрываем popup
        closePopup();

        // Обрабатываем полученные данные
        handleOAuthSuccess(tokenData);
      }
    };

    window.addEventListener('message', messageHandler);

    return () => {
      console.log('closePopup в return useEffect');
      window.removeEventListener('message', messageHandler);
      closePopup();
    };
  }, [successCallback]);

  // Функция открытия popup окна
  const openAuthPopup = async (space) => {
    try {
      // Закрываем предыдущее popup окно, если оно есть
      closePopup();

      // Получаем URL для авторизации
      const authUrl = await getAuthUrl(space);

      // Настройки popup окна
      const width = 600;
      const height = 700;
      const left = (window.screen.width - width) / 2;
      const top = (window.screen.height - height) / 2;

      console.log('Opening popup with URL:', authUrl);

      // Открываем popup окно
      const newPopup = window.open(
        authUrl,
        'OAuth Authentication',
        `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes`
      );

      if (!newPopup) {
        throw new Error('Popup blocked. Please allow popups for this site.');
      }

      console.log(popupRef);
      console.log(newPopup);

      popupRef.current = newPopup;

      // Проверяем, закрылось ли popup (например, пользователь закрыл вручную)
      intervalRef.current = setInterval(() => {
        console.log(newPopup);
        if (newPopup.closed) {
          clearPopupInterval();
          popupRef.current = null;
          setError('Authentication was cancelled');
        }
      }, 1000);
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className='auth-buttons'>
      <div className='auth-providers'>
        <button className='auth-provider-btn' onClick={() => openAuthPopup('magma')}>
          <span className='provider-icon'>
            <FinanceLogo height={20} width={20} />
          </span>
          <span className='provider-name'>LOGIN WITH MAGMA FINANCE</span>
        </button>

        {/*<button className='auth-provider-btn' onClick={() => openAuthPopup('finarium')}>*/}
        {/*  <span className='provider-icon'>*/}
        {/*    <CryptoLogo height={20} width={20} />*/}
        {/*  </span>*/}
        {/*  <span className='provider-name'>FINARIUM</span>*/}
        {/*</button>*/}

        {/*<button className='auth-provider-btn'>*/}
        {/*  <span className='provider-icon'>*/}
        {/*    <UnifyLogo height={20} width={20} />*/}
        {/*  </span>*/}
        {/*  <span className='provider-name'>UNIFY</span>*/}
        {/*</button>*/}
      </div>

      <div className='auth-links'>
        <NavLink to={`${route}/registration/verification/email`} className={'link'}>
          <Button className='create-account-btn' style={{ width: '100%' }} size={'large'} type={'dashed'}>
            <div className='text'>
              <AddUser /> <span>CREATE AN ACCOUNT</span>
            </div>
          </Button>
        </NavLink>

        <div className='reset'>
          <NavLink to={`${route}/password-reset`} className={'link'}>
            <div className='text'>
              <Reset /> <span>RESET PASSWORD</span>
            </div>
          </NavLink>
        </div>
      </div>
    </div>
  );
};

OAuthPopup.propTypes = {
  successCallback: PropTypes.func,
  route: PropTypes.string,
};

export default OAuthPopup;
